import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {labelProperties, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class AngleLabelExpressionBuilderService {
    title = 'AngleLabelExpressionBuilder';

    constructor(private labelExpressionUtilityService: LabelExpressionUtilityService) {}

    build(attributes: Attributes) {
        switch (attributes.type) {
            case 12:
                return this.buildCadastreAngles(attributes);
            case 13:
                return this.buildInterestAngles(attributes);
            default:
                console.debug(`${this.title} - build - type ${attributes.type} not supported`);
                return null;
        }
    }

    buildCadastreAngles(attributes: Attributes) {
        const labels = [];
        const labelProperties = {} as labelProperties;

        this.formattedDMS(attributes.internalangle, attributes.measurementsource);

        if (attributes.internalangle) {
            labels.push(
                this.labelExpressionUtilityService.getLabelProperties(
                    '10em',
                    'normal',
                    'start',
                    this.formattedDMS(attributes.internalangle, attributes.measurementsource)
                )
            );

            labelProperties.labels = labels;
            labelProperties.labelExpression = attributes.internalangle;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildInterestAngles(attributes: Attributes) {
        const labels = [];
        const labelProperties = {} as labelProperties;

        // DMS style angle
        if (attributes.internalangle) {
            labels.push(
                this.labelExpressionUtilityService.getLabelProperties(
                    '7.2em',
                    'normal',
                    'start',
                    this.formattedDMS(attributes.internalangle, attributes.measurementsource)
                )
            );

            labelProperties.labels = labels;
            labelProperties.labelExpression = attributes.internalangle;
            return labelProperties;
        } else {
            return null;
        }
    }

    formattedDMS(dms: string, measurementSourceId: string) {
        const dmsParts = dms.split(/[^\d]+/);

        const degrees = dmsParts[0] ? parseInt(dmsParts[0]).toString() : '0';
        const minutes = dmsParts[1] ? parseInt(dmsParts[1]).toString() : '0';
        const seconds = dmsParts[2] ? parseInt(dmsParts[2]).toString() : '0';
        const measurementSource = this.measurementSourceLookup(measurementSourceId);

        if (minutes === '0' && seconds === '0') {
            console.log(measurementSource ? degrees + '\u00b0' + measurementSource : degrees + '\u00b0');
            return measurementSource ? degrees + '\u00b0' + measurementSource : degrees + '\u00b0';
        }

        if (seconds === '0') {
            return measurementSource ? degrees + '\u00b0' + minutes + '\u0027' + measurementSource : degrees + '\u00b0' + minutes + '\u0027';
        }

        return measurementSource
            ? degrees + '\u00b0' + minutes + '\u0027' + seconds + '\u0022' + measurementSource
            : degrees + '\u00b0' + minutes + '\u0027' + seconds + '\u0022';
    }

    measurementSourceLookup(id: string) {
        const measurementSource = parseInt(id);
        if (measurementSource) {
            switch (measurementSource) {
                case 2:
                    return ' orig';
                case 3:
                    return ' p.orig';
                case 4:
                    return ' cal';
                default:
                    return null;
            }
        }
        return null;
    }
}
